import React from "react";
import { useMediaQuery, Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { theme } from "../Template";
import CustomButton from '../../Template3/components/CustomButton';
import SocialIcons from '../../shared/components/SocialIcons';
import SectionLayout from '../../shared/layout/SectionLayout';
import useRTL from 'src/hooks/useRTL';
import { textVariant, textClasses } from '../../shared/config';

const useStyles = makeStyles(theme => ({
  
  boxRoot:props=> ({
    // backgroundImage: `linear-gradient(to right, ${props.transparencyColor}, ${props.transparencyColor}), url(${props.image})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: props.bannerStyle === 'boxed' && props.page === 'home' ? "90%" : "100%" ,

    height: props.matches && props.page === 'home' ? props.bannerMobileHeight ? `${props.bannerMobileHeight}px` : '600px' :
    (props.page === 'home' && props.bannerMaxHeight) ? `${props.bannerMaxHeight}px` : 
    props.height ? props.height : 'auto',

    maxHeight: 
    props.page === 'home' ? 
    props.matches ? (props.bannerMobileHeight ? `${props.bannerMobileHeight}px` : '600px') : 
    props.bannerMaxHeight ? `${props.bannerMaxHeight}px`: '' : '',
    borderRadius: props.bannerStyle === 'fullWidth' ? '0px' : '20px',
    [theme.breakpoints.down('sm')]: {
      width:'100%',
      borderRadius:'0px',
      marginTop:'-1px'
    },
    ...(props.bannerStyle === 'boxed' && props.page === 'home' ? {marginLeft:'auto',marginRight:'auto'} : {}),
    '&::before':{
      content: "''",
      position: "absolute",
      width: "100%",
      height: props.matches && props.page === 'home' ? props.bannerMobileHeight ? `${props.bannerMobileHeight}px` : '600px': 
      (props.page === 'home' && props.bannerMaxHeight) ? `${props.bannerMaxHeight}px` : 
      props.height ? props.height : 'auto',
      ...(props.flipBannerImage ? {...{transform: props.isRTL === 'en' ? 'scaleX(1)' : 'scaleX(-1)'}} : {}),
      backgroundImage: `linear-gradient(to right, ${props.transparencyColor}, ${props.transparencyColor}), url(${props.image})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: 'center center',
      ...(props.bannerPaddingTop ? {...{paddingTop:`${props.bannerPaddingTop}px`}} : {})
    },
  }),

  colDiv_45:{
    maxWidth:'45%'
  },

  colDiv_100:{
    width:'100%'
  },

  bannerImg:props=>({
    width: props.bannerImageSize ? `${props.bannerImageSize}px` : '500px',

    '& img':{
      width:'100%',
      height:'100%'
    },

    [theme.breakpoints.down('sm')]:{
      width:'100% !important'
    }
  }),

  subTitle:{
    alignSelf: 'center',
    outline: 'none',
    border: 'none',
    width: '100%',
    margin: '10px 0px',
    color:'#000',
    fontFamily: "'Poppins', sans-serif",
    borderRadius: '8px',
    boxSizing:"border-box"
  },

  justifyFlexStart:{
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-start'
  },

  justifyFlexEnd:{
    display:'flex',
    justifyContent:'flex-end'
  },

  colDivCenter:{
    display:'flex',
    flexDirection:'column',
    alignItems:'center',
    justifyContent:'center'
  }
}));

const Header = ({ height, title, image, children, transparencyColor, displayBanner,bannerStyle, titleColor, page, data, customCls, onClickEvent, ...props }) => {
  const { bannerSubTitle,bannerFontColor, templateLang, flipBannerImage, generalTitleFontSize, generalSubTitleFontSize, bannerSubTitleFontColor, bannerTitleDirection, spaceBetweenContent, bannerSpaceBetween, bannerImage, bannerImageSize, bannerPaddingBottom, bannerPaddingTop, bannerMaxHeight, bannerTextAlignment, bannerImageAlignment, bannerMobileHeight, isRTL, titleFontSize, subTitleFontSize, showHeaderSocialIcon=true, demoHeader,
    companyDomain,
    // default
    buttonColor,buttonFontColor, autoButtonSize, buttonWidth, buttonHeight,buttonRadiusGeneral, buttonFontSize,
    // button
    bannerShowButton, bannerButtonColor, bannerButtonFontColor, bannerAutoButtonSize, bannerButtonWidth, bannerButtonHeight, bannerButtonRadius, bannerButtonBorder,
    bannerButtonPath, bannerButtonExternalLink, bannerButtonFontSize, bannerButtonTitle, arBannerButtonTitle,

    // image
    bannerImageAlt,bannerImageRadius, bannerImageShadow, bannerImageShadowContent,bannerImageBorder,

    // text 
    bannerTextRadius,bannerTextBackground,bannerTextBorder
  } = data || {};
  const { pathname:url } = useLocation();
  const navigate = useNavigate();
  const { twitterPage, youtube,  facebookPage, instagramPage, linkedin, tiktok, telegram, snapchat } = data.companyData || {};
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const matches720 = useMediaQuery('(min-width:720px)');
  const classes = useStyles({flipBannerImage,templateLang,isRTL,bannerStyle,transparencyColor,matches,image,height,bannerImage,bannerMobileHeight,bannerImageSize,bannerMaxHeight,page,bannerPaddingTop});
  const [, , fontFamily] = useRTL('',"Playfair Display, serif");
  const _textAlign = !matches720 ? 'center' : bannerTitleDirection === 'right' && page === 'home' ? isRTL === 'ar' ? 'right' : 'right' : bannerTitleDirection === 'left' && page === 'home' ? isRTL === 'ar' ? 'right' : 'left' : 'center';
  


  const buttonEvent = () => {
    if(bannerButtonPath) {
      var _path = url?.split('/temp')[0];
      navigate(companyDomain ? `/temp/${bannerButtonPath}` : `${_path}/temp/${bannerButtonPath}`)
    }
    else{
      window.open(bannerButtonExternalLink,'_blank')
    }
  };

  // button
  const _buttonColor = bannerButtonColor ? bannerButtonColor : buttonColor ? buttonColor : 'inherit';
  const _buttonFontColor = bannerButtonFontColor ? bannerButtonFontColor : buttonFontColor ? buttonFontColor : 'inherit';
  const _buttonWidth = bannerAutoButtonSize || autoButtonSize ? 'fit-content' : bannerButtonWidth ? `${bannerButtonWidth}px` :
  buttonWidth ? `${buttonWidth}px` : 'fit-content';
  const _buttonHeight = bannerAutoButtonSize || autoButtonSize ? 'unset' : bannerButtonHeight ? `${bannerButtonHeight}px` :
  buttonHeight ? `${buttonHeight}px` : 'unset';
  const btnRadius = bannerButtonRadius ? `${bannerButtonRadius}px` : buttonRadiusGeneral ? `${buttonRadiusGeneral}px` : '0px'; 
  const _buttonFontSize = bannerButtonFontSize ? bannerButtonFontSize : buttonFontSize ? buttonFontSize : '16';
  const buttonTitle = isRTL === 'ar' && arBannerButtonTitle ? arBannerButtonTitle : bannerButtonTitle;

  // image
  const imgRadius = bannerImageRadius ? `${bannerImageRadius}px` : '0px'; 

  const rightPadding = isRTL === 'ar' ? (spaceBetweenContent ? `0px ${spaceBetweenContent}px 16px 0px` : '0px 20px 16px 0px') : (spaceBetweenContent ? `0px 0px 16px ${spaceBetweenContent}px` : '0px 0px 16px 20px');
  const leftPadding = isRTL === 'ar' ? (spaceBetweenContent ? `0px 0px 16px ${spaceBetweenContent}px` : '0px 0px 16px 20px') : (spaceBetweenContent ? `0px ${spaceBetweenContent}px 16px 0px` : '0px 20px 16px 0px');

  const subTitle = isRTL === 'ar' && data?.arBannerSubTitle ? data?.arBannerSubTitle : bannerSubTitle || '';

  if(displayBanner) 
  return (
    <Box
      overflow="hidden"
      position="relative"
      className={classes.boxRoot}
      m="auto"
      {...(onClickEvent ? {onClick:onClickEvent} : {})}
      {...props}
    >
      <SectionLayout 
      style={{position:'relative',height:'100%'}} disableTopPadding disableBottomPadding
      >
        <Box
          height="100%"
          display="flex"
          // flexDirection="column"
          flexDirection={page !== 'home' || !matches720 ? 'column' : bannerTitleDirection === 'center' ? "column-reverse" : bannerTitleDirection === 'right' ? 'row-reverse' : "row"}
          alignItems={{xs:'center'}}
          // justifyContent="center"
          justifyContent={page !== 'home' || bannerTitleDirection === 'center' || !matches720 ? 'center' : bannerTitleDirection === 'right' && bannerSpaceBetween === 'flex-start' ? 'flex-end' : bannerTitleDirection === 'right' && bannerSpaceBetween === 'flex-end' ? 'flex-start' : bannerSpaceBetween ? bannerSpaceBetween : "space-between"}
          fontWeight={700}
          color="white"
        >
          <Box
            pb={2}
            fontSize={{ xs: "2rem", sm: "3rem" }}
            fontFamily={fontFamily}
            zIndex={1}
            style={{textTransform:'capitalize',padding: 
              !matches720 ? '0px 10px 16px 10px' : 
              bannerTitleDirection === 'right' && ['flex-start','flex-end','center'].includes(bannerSpaceBetween) ? rightPadding :
              bannerTitleDirection === 'left' && ['flex-start','flex-end','center'].includes(bannerSpaceBetween) ? leftPadding : '0px',
              alignSelf: matches ? 'center' : page !== 'home' ? '' : bannerTextAlignment ? bannerTextAlignment : "center",
              ...(bannerTitleDirection === 'center' ? {marginTop:'20px'} : {}),
              ...(bannerTextBorder && page === 'home' ? {border: bannerTextBorder} : {}),...(bannerTextBackground && page === 'home' ? {background: bannerTextBackground} : {}),...(bannerTextRadius && page === 'home' ? {borderRadius: `${bannerTextRadius}px`} : {})
            }}
            className={`${!matches720 ? '' : bannerTitleDirection === 'center' ? classes.colDiv_100 : classes.colDiv_45} ${bannerTitleDirection === 'left' ? classes.justifyFlexStart : ''} ${customCls ? customCls : ''}`}
          >
            <Typography 
              variant={titleFontSize && textVariant?.[titleFontSize] ? textVariant?.[titleFontSize] : generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62']}
              className={titleFontSize && textClasses?.[titleFontSize] ? textClasses?.[titleFontSize] : generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62']}
              style={{color:titleColor,textAlign: _textAlign}}>
              {demoHeader || title}
            </Typography>
            {subTitle && page === 'home' ?
            <Typography
              variant={subTitleFontSize && textVariant?.[subTitleFontSize] ? textVariant?.[subTitleFontSize] : generalSubTitleFontSize && textVariant?.[generalSubTitleFontSize] ? textVariant?.[generalSubTitleFontSize] : textVariant?.['18']}
              className={`${subTitleFontSize && textClasses?.[subTitleFontSize] ? textClasses?.[subTitleFontSize] : generalSubTitleFontSize && textClasses?.[generalSubTitleFontSize] ? textClasses?.[generalSubTitleFontSize] : textClasses?.['18']} ${classes.subTitle}`}
              style={{color:bannerSubTitleFontColor || '',textAlign:_textAlign}}
              >
                <span className={classes.tp} style={{fontFamily:data?.fontFamily}}>{subTitle}</span>
            </Typography>
            : null}

            {bannerShowButton && page === 'home' ?
            <div style={{width:'100%',textAlign:_textAlign}}>
              <CustomButton
                style={{
                    backgroundColor: _buttonColor,
                    textTransform:'capitalize',
                    color: _buttonFontColor,
                    width: _buttonWidth,
                    height: _buttonHeight,
                    borderRadius: btnRadius,
                    fontFamily: data?.fontFamily,
                    ...(bannerButtonBorder ? {border:bannerButtonBorder} : {})
                }}
                onClick={buttonEvent}
                className={textClasses?.[_buttonFontSize]}
                >
                {buttonTitle}
              </CustomButton>
            </div>
            : null}
          </Box>
          {page === 'home' && bannerImage ?
          <div className={`${!matches720 ? '' : classes.colDiv_45} ${bannerTitleDirection === 'left' ? classes.justifyFlexEnd : bannerTitleDirection === 'center' ? classes.colDivCenter : ''}`}
            style={{alignSelf: matches ? 'center' : page !== 'home' ? '' : bannerImageAlignment ? bannerImageAlignment : "center",zIndex:1}}
          >
              <div className={classes.bannerImg} style={{borderRadius: imgRadius}}>
                <img src={bannerImage}
                  alt={bannerImageAlt ? bannerImageAlt : 'banner'}
                  style={{
                    borderRadius: imgRadius,
                    ...(bannerImageBorder ? {border:bannerImageBorder} : {}),
                    ...(bannerImageShadow && bannerImageShadowContent ? {boxShadow:bannerImageShadowContent} : {})
                  }}
                />
              </div>
          </div>
          : null }
          {page !== 'home' ?
          <Box fontWeight="500" fontFamily="roboto, sans-serif" zIndex={1}>
            {children}
          </Box>
          : null}
        </Box>
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          position="absolute"
          left="0"
          bottom="20px"
        >
          { showHeaderSocialIcon ?
          <SocialIcons
            color="white"
            mb={2}
            border="1px solid white"
            twitterLink={twitterPage}
            youtubeLink={youtube}
            facebookLink={facebookPage}
            instagramLink={instagramPage}
            linkedinLink={linkedin}
            tiktokLink={tiktok}
            telegramLink={telegram}
            snapchatLink={snapchat}
          />
          : null }
        </Box>
        </SectionLayout>
    </Box>
  );

  return null;
};

export default Header;
